export const DOWNLOAD_APP_BANNER_TITLE = "Avail the offer by using Swiggy app";
export const DOWNLOAD_APP_BANNER_SUBTITLE = "Pay the dining bill via Swiggy app, your offer gets auto applied!";

export const CART_PAGE_TEXTS = {
    TnCHeaderWithOffer: "Offer terms & conditions",
    TnCHeaderWithoutOffer: "Restaurant terms & conditions",
    EventTnC: "Event terms and conditions",
    ThingsToRemember: "Things to remember",
    FreeReservationProceedCta: "Book your table for Free",
    PrebookReservationProceedCta: "Proceed to pay ₹{0}",
    FreeEventReservationProceedCta: "Book your ticket for Free",
};

export const FETCHING_CART_TEXT = "Fetching your booking details ... ";

export const BILL_DETAILS_TEXTS = {
    BillDetails: "Bill Details",
};

export const ONE_UPSELL_BENEFITS_HALFCARD = {
    imageSrc: "MERCHANDISING_BANNERS/IMAGES/MERCH/2024/5/23/28b39e4d-cd35-429d-b948-0bcd0246af34_FoodIMDOGenie5.png",
    ctaText: "Got it",
};

export const BOOKING_STATUS_TO_COLORCODE_MAPPING: { [key: string]: string } = {
    completed: "positive",
    confirmed: "positive",
    pending: "highlight",
    cancelled: "negative",
    failed: "negative",
};

export const LABEL_TYPES: { [key: string]: string } = {
    TITLE: "title",
    TAG: "tag",
};

export const CART_META_DATA_TYPE = "DineoutCartMetaData";

export const CART_TYPE = "DEAL_TICKET_PURCHASE";

export const SERVICE_LINE = "DINEOUT";

export const SOURCE = "direct-payment-cart";

export const IS_FROM_DINEOUT_CART = "isFromDineoutCart";
export const DINEOUT_FLOW_TYPE_SESSION_STORAGE_KEY = "dineout_flow_type_session_storage_key";

export const USE_V2_LOCAL_CART_FORMAT_STORAGE_KEY = "use_v2_local_cart_format";

export const DINEOUT_CART_PAYLOAD = "dineout_cart_payload";

export const TEST_GET_DINEOUT_CART = "__test_get_dineout_cart__";

export const CTA_BUTTON_TEXT = "{0} {1}";

export const DEAL_CATEGORY = {
    BAU: "Pre-Book",
    GIRF: "GIRF",
    RESERVATION: "RESERVATION",
    EVENTS: "EVENTS",
};

export const BILL_ELEMENT_ENTRIES = {
    CONVENIENCE_FEE_TYPE: "convenienceFee",
    INR_CURRENCY_SYMBOL: "₹",
};

export const EMPTY_STATE_HEADER = {
    name: "",
    locality: "",
    city: "",
};

export const EVENT_HEADER_TEXT = {
    name: "Review Booking Details",
    city: "",
    locality: "",
};

export const UNAVAILABLE_ITEMS_CTA_SUBTEXT = {
    heading: "{0} ticket(s) is sold out",
    subtext: "You can remove sold out ticket and continue",
    ctaText: "Remove sold out tickets",
    errorIcon: {
        cloudinaryId: "PaymentLogos/paymentIcons/error",
        width: "18",
        height: "18",
    },
};

export const OOS_POPUP_TEXT = {
    COMPLETE_OOS: {
        title: "You just missed it!",
        subTitle: "Your selected tickets just got sold out. Try selecting available tickets",
        primaryButtonText: "View tickets",
        secondaryButtonText: "Cancel",
    },
    PARTIAL_OOS: {
        title: "Some tickets are sold out!",
        subTitle: "Some of your selected tickets just got sold out. Please update your cart to proceed",
        secondaryButtonText: "Okay",
        primaryButtonText: "",
    },
};

export const TICKET_COUNT = {
    MAX: 10,
    MIN: 0,
};

export const INC = "INC";

export const VALIDATION_LOADER_TEXT = "Checking status ...";

export const EMPTY_TICKET_STATE_TEXT = {
    MAIN_TEXT: "What’s the Scene?",
    SUB_TEXT: "Your ticket cart is empty :(",
    SUB_TEXT_SECOND: "Find cool events to match your vibe",
    IMAGE_URL: { dark: "seo%20web/illustration_dark.png", light: "seo%20web/illustration.png" },
    BUTTON_TEXT: "Browse events",
};

export const SAVINGS_HEADER_WIDGET_TYPES = [
    "REVIEW_BOOKING_COVER_CHARGES",
    "DINEOUT_CART_SCREEN_SAVING_WIDGET",
    "PREBOOK_PREPAID_SAVING_WIDGET",
];

export const CART_UI_WIDGETIDS = {
    PREBOOK_PREPAID_CANCELLATION_WIDGET: "PREBOOK_PREPAID_CANCELLATION_WIDGET",
};

export const VALIDATION_LOADER_POPUP_WIDTH = "700px";

export const REDEMPTION_META_SECTION_KEYS = {
    VALIDITY_RULES: "validity_rules",
    HOW_TO_REDEEM: "how_to_redeem",
    TNC: "terms_and_conditions",
};